import { ProcedureToUpdate } from '@/modules/copay/entities/interfaces/usageStatements';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class ProcedureService extends HttpClientAdapter {
  constructor() {
    super('FINANCIAL');
  }

  updateMany(payload: Partial<ProcedureToUpdate>[]) {
    return this.patch('/procedures/update-procedures', payload);
  }
}
